/* Thème GÖTA — comportements. Aucune dépendance. Compatible éditeur de thème.
   Les transitions entre pages sont en CSS pur (voir layout/theme.liquid).
   Règle de fond : rien de ce qui rend le contenu visible ne doit pouvoir casser.
   Les garde-fous CSS vivent dans le <head> de layout/theme.liquid. */
(() => {
'use strict';

const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const EDITOR = !!(window.Shopify && window.Shopify.designMode);

/* sessionStorage peut lever une exception (navigation stricte, cookies bloqués). */
const store = {
  get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
};

/* Une brique qui casse ne doit jamais emporter les autres. */
const safe = fn => { try { fn(); } catch (e) { console.warn('[gota]', e); } };

/* --- Révélations au scroll ------------------------------------------------
   L'IntersectionObserver ne se déclenche pas dans un onglet ouvert en
   arrière-plan, ni dans certains navigateurs stricts. On double donc la
   sécurité : balayage manuel au scroll, au retour sur l'onglet, et deux
   filets temporisés. Sans cela, un visiteur voit une page blanche.       */
const RV_SEL = '.rv,.rv-clip';
const rvShow = e => e.classList.add('is-in');

function rvSweep(root = document) {
  const vh = innerHeight || 800;
  $$(RV_SEL, root).forEach(e => {
    if (e.classList.contains('is-in')) return;
    if (e.getBoundingClientRect().top < vh * 0.94) rvShow(e);
  });
}

function reveals(root = document) {
  const els = $$(RV_SEL, root).filter(e => !e.dataset.rvBound);

  if (RM || typeof IntersectionObserver !== 'function') {
    els.forEach(rvShow);
    return;
  }

  const io = new IntersectionObserver(ents => {
    ents.forEach(en => {
      if (en.isIntersecting) { rvShow(en.target); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
  els.forEach(e => { e.dataset.rvBound = '1'; io.observe(e); });

  if (!reveals._guard) {
    reveals._guard = true;
    let tick = false;
    addEventListener('scroll', () => {
      if (tick) return;
      tick = true;
      requestAnimationFrame(() => { tick = false; rvSweep(); });
    }, { passive: true });
    addEventListener('resize', () => rvSweep(), { passive: true });
    addEventListener('pageshow', () => rvSweep());
    document.addEventListener('visibilitychange', () => { if (!document.hidden) rvSweep(); });
    setTimeout(() => rvSweep(), 1200);
    setTimeout(() => $$(RV_SEL).forEach(rvShow), 4000);   // dernier recours
  }

  rvSweep(root);
}

function parallax() {
  const paraEls = $$('[data-para]');
  if (!paraEls.length || RM) return;
  let tick = false;
  const run = () => {
    const vh = innerHeight;
    paraEls.forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const p = (r.top + r.height / 2 - vh / 2) / vh;
      const amt = parseFloat(el.dataset.para) || 8;
      const img = el.querySelector('img') || el;
      img.style.transform = `scale(1.12) translate3d(0,${(-p * amt).toFixed(2)}%,0)`;
    });
    tick = false;
  };
  addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
  addEventListener('resize', run);
  run();
}

function headerScroll() {
  const hdr = $('[data-header]');
  if (!hdr) return;
  const darkSel = '.st-hero, .slide, .lst-hero, .split';
  const run = () => {
    hdr.classList.toggle('is-solid', scrollY > 24 && !document.body.classList.contains('tpl-index'));
    const probe = hdr.getBoundingClientRect().bottom - 12;
    let dark = false;
    $$(darkSel).forEach(z => {
      const r = z.getBoundingClientRect();
      if (r.top <= probe && r.bottom >= probe) dark = true;
    });
    hdr.dataset.theme = dark ? 'dark' : 'light';
  };
  addEventListener('scroll', run, { passive: true });
  addEventListener('resize', run);
  run();
}

function cursor() {
  if (matchMedia('(pointer:coarse)').matches || EDITOR) return;
  const c = document.createElement('div');
  c.className = 'cur';
  c.innerHTML = '<span class="cur__t"></span>';
  document.body.append(c);
  const t = $('.cur__t', c);
  let x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y;
  addEventListener('mousemove', e => { x = e.clientX; y = e.clientY; }, { passive: true });
  (function loop() {
    cx += (x - cx) * .18; cy += (y - cy) * .18;
    c.style.transform = `translate(${cx}px,${cy}px) translate(-50%,-50%)`;
    requestAnimationFrame(loop);
  })();
  document.addEventListener('mouseover', e => {
    const h = e.target.closest('[data-cursor]');
    if (h) { c.classList.add('is-lg'); t.textContent = h.dataset.cursor; }
    else if (!e.target.closest('.cur')) c.classList.remove('is-lg');
  });
}

/* On anime le viewBox du SVG, pas un transform : le tracé est redessiné
   à chaque image, donc il reste net quel que soit le grossissement. */
function opening() {
  const w = $('[data-opening]');
  if (!w) return;
  const hdr = $('[data-header]');
  const once = w.dataset.once === 'true';
  const played = store.get('gota-opened') === '1';
  if (once && played && !EDITOR) { w.remove(); return; }

  const svg = $('.opening__stage svg', w);
  const tag = $('.opening__tag', w);
  if (RM || !svg) { w.remove(); return; }

  const vb = (svg.dataset.vb || '0 0 2295.97 2121.16').split(' ').map(Number);
  const VW = vb[2], VH = vb[3];
  const CX = vb[0] + VW / 2, CY = vb[1] + VH / 2;

  const num  = (k, d) => { const v = parseInt(w.dataset[k], 10); return isNaN(v) ? d : v; };
  const GROW = num('grow', 1500), HOLD = num('hold', 500), ZOOM = num('zoom', 1200);
  const START = 260, DOT = 11;

  const fit   = () => Math.min(innerWidth / VW, innerHeight / VH);
  const sFor  = px => VW * fit() / px;
  const logoW = () => Math.min(innerWidth * 0.52, 760);

  const setS = s => {
    const bw = VW * s, bh = VH * s;
    svg.setAttribute('viewBox', `${CX - bw / 2} ${CY - bh / 2} ${bw} ${bh}`);
  };

  const ease = t => (t < .5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2);
  let raf = 0;

  const tween = (from, to, dur) => new Promise(res => {
    const t0 = performance.now();
    const step = now => {
      const p = Math.min(1, (now - t0) / dur);
      setS(from * Math.pow(to / from, ease(p)));
      if (p < 1) raf = requestAnimationFrame(step); else res();
    };
    raf = requestAnimationFrame(step);
  });

  const wait = ms => new Promise(r => setTimeout(r, ms));

  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    cancelAnimationFrame(raf);
    store.set('gota-opened', '1');
    if (hdr) hdr.style.opacity = '';
    w.classList.add('is-done');
    w.animate([{ opacity: 1 }, { opacity: 0 }],
      { duration: 620, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' })
     .finished.then(() => { if (EDITOR) { w.style.display = 'none'; } else { w.remove(); } });
  };

  if (hdr) hdr.style.opacity = 0;
  setS(sFor(DOT));

  if (tag) {
    tag.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
      { duration: 700, delay: START + GROW * 0.45, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
  }

  (async () => {
    await wait(START);
    await tween(sFor(DOT), sFor(logoW()), GROW);
    await wait(HOLD);
    if (tag) tag.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 380, fill: 'forwards' });
    await tween(sFor(logoW()), sFor(logoW() * 9), ZOOM);
    finish();
  })();

  w.addEventListener('click', finish);
  setTimeout(finish, START + GROW + HOLD + ZOOM + 2500);
}

function shopFilters(root = document) {
  const bar = $('[data-filters]', root);
  if (!bar) return;
  const cards = $$('.card', document);
  bar.addEventListener('click', e => {
    const b = e.target.closest('button[data-f]');
    if (!b) return;
    $$('button[data-f]', bar).forEach(x => x.classList.toggle('is-on', x === b));
    const f = b.dataset.f;
    cards.forEach(c => {
      const tags = (c.dataset.tags || '').split(' ');
      const on = f === 'all' || tags.indexOf(f) !== -1;
      c.classList.toggle('is-hidden', !on);
      if (on) { c.style.opacity = 0; requestAnimationFrame(() => { c.style.opacity = ''; }); }
    });
  });
}

function productForm() {
  const form = $('.pdp__form', document);
  if (!form) return;
  const select = $('[data-variant-select]', form);
  const price  = $('[data-price]', document);
  if (!select) return;

  form.addEventListener('change', () => {
    const chosen = $$('input[type=radio]:checked', form).map(i => i.value);
    if (!chosen.length) return;
    const opt = [...select.options].find(o => {
      const parts = (o.dataset.title || o.textContent).split(' / ').map(s => s.trim());
      return chosen.length === parts.length && chosen.every((v, i) => parts[i] === v);
    });
    if (!opt) return;
    select.value = opt.value;
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    const btn = $('button[name=add]', form);
    if (btn) {
      btn.disabled = opt.disabled;
      btn.textContent = opt.disabled ? 'Épuisé' : (btn.dataset.label || 'Ajouter au panier');
    }
  });
}

function boot() {
  safe(reveals); safe(parallax); safe(headerScroll); safe(cursor);
  safe(opening); safe(shopFilters); safe(productForm);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

document.addEventListener('shopify:section:load', e => {
  safe(() => reveals(e.target)); safe(parallax); safe(headerScroll);
  safe(() => shopFilters(e.target)); safe(productForm); safe(opening);
});
document.addEventListener('shopify:section:select', () => safe(reveals));
})();
